import update from 'immutability-helper';
import _ from '../services/lodash';
import React from '../services/React';
import UI from '../services/UI';
import TimeDropdown from './TimeDropdown';
import {
  validateOpeningHours,
  extractHoursAndMinutes,
  INVALID_RANGE,
  INVALID_TIME_STRING,
  OVERLAPPING_RANGE
} from '../services/openingHours';
import './TimeRanges.css';

const validationMessages = {
  [INVALID_RANGE]: 'Time range is invalid',
  [INVALID_TIME_STRING]: 'Time is invalid',
  [OVERLAPPING_RANGE]: 'Time ranges are overlapping'
};

const defaultFrom = '00:00';
const defaultTo = '00:00';

const MAX_TIMERANGES = 3;

class TimeRanges extends React.Component {
  constructor(props) {
    super(props);

    this.removeTimerange = this.removeTimerange.bind(this);
    this.addTimerange = this.addTimerange.bind(this);
    this.isAddTimerangeDisabled = this.isAddTimerangeDisabled.bind(this);
    this.updateTimeranges = this.updateTimeranges.bind(this);
    this.updateRangeValue = this.updateRangeValue.bind(this);

    const errors = validateOpeningHours(props.timeranges || []);

    this.state = {
      timeranges: props.timeranges,
      errors: errors
    };
  }

  componentWillReceiveProps(nextProps) {
    let timeranges = nextProps.timeranges;
    if (timeranges !== this.props.timeranges) {
      let errors = validateOpeningHours(timeranges);
      this.setState({ timeranges, errors });
    }
  }

  addTimerange() {
    const { timeranges } = this.state;
    let from;
    let to;

    if (!timeranges.length) {
      from = '08:00';
      to = '12:00';
    } else {
      const lastRange = _.last(timeranges);
      const extractedTo = extractHoursAndMinutes(lastRange.to);

      if (
        extractedTo.hours <= 22 &&
        (lastRange.from !== '00:00' && lastRange.to !== '00:00')
      ) {
        from = `${_.padStart(extractedTo.hours + 1, 2, '0')}:00`;
        to = `${_.padStart(extractedTo.hours + 2, 2, '0')}:00`;
      } else {
        // TODO: not sure if this makes sense here..
        from = defaultFrom;
        to = defaultTo;
      }
    }

    const newTimeranges = timeranges.concat([{ from, to }]);

    this.updateTimeranges(newTimeranges);
  }

  removeTimerange(idxToRemove) {
    const { timeranges } = this.state;
    const newTimeranges = timeranges.filter((range, i) => i !== idxToRemove);

    this.updateTimeranges(newTimeranges);
  }

  updateRangeValue(i, key, val) {
    // No change
    if (val === this.state.timeranges[i][key]) {
      return;
    }

    // Update timeranges, validate and save errors
    const newTimeranges = update(this.state.timeranges, {
      [i]: { [key]: { $set: val } }
    });

    this.updateTimeranges(newTimeranges);
  }

  updateTimeranges(newTimeranges) {
    const errors = validateOpeningHours(newTimeranges);

    this.setState(() => ({
      timeranges: newTimeranges,
      errors
    }));

    if (!errors.length) {
      this.props.onChange(newTimeranges);
    }
  }

  isAddTimerangeDisabled() {
    const { timeranges } = this.state;

    if (timeranges.length >= MAX_TIMERANGES) {
      return true;
    }

    if (timeranges.length) {
      const lastRange = _.last(timeranges);
      return lastRange.to === '24:00';
    }

    return false;
  }

  render() {
    // List errors
    let errorTypes = _.uniq(this.state.errors.map(({ type }) => type));

    let errorMsg;
    if (errorTypes.length) {
      errorMsg = (
        <div className="errors">
          <div className="control-section-divider labeled">
            {errorTypes.map(err => validationMessages[err]).join(', ')}
          </div>
        </div>
      );
    }

    // For marking invalid fields
    // let invalidFields = this.state.errors.reduce(
    //   (fields, err) => fields.add(err.path),
    //   new Set()
    // );

    // let isValid = (i, key) =>
    //  !(invalidFields.has(`${i}.${key}`) || invalidFields.has(`${i}`));

    // List time ranges
    let timeranges;
    // Omit table when empty

    if (this.state.timeranges.length) {
      timeranges = this.state.timeranges.map((timerange, i) => {
        return (
          <div key={i}>
            <hr className="divider-long" />
            <UI.sectionDividerLabeled label={`Time Slot ${i + 1}`} />
            <hr className="divider-long" />
            {errorMsg}
            <TimeDropdown
              value={timerange.from}
              title="From"
              onChange={newVal => this.updateRangeValue(i, 'from', newVal)}
            />
            <hr className="divider-short" />
            <TimeDropdown
              value={timerange.to}
              title="To"
              onChange={newVal => this.updateRangeValue(i, 'to', newVal)}
            />
            <hr className="divider-short" />
            <div className="DeleteButton__Wrapper">
              <UI.button
                label={`Delete Time Slot ${i + 1}`}
                className="btn-text"
                onClick={() => this.removeTimerange(i)}
              />
            </div>
          </div>
        );
      });
    }

    let tooltipHTML;

    if (this.isAddTimerangeDisabled()) {
      tooltipHTML = (
        <div className="TimeRanges__TooltipWrapper">
          <UI.tooltip value="You’ve reached the maximum number of time slots.">
            <UI.symbol name="info" />
          </UI.tooltip>
        </div>
      );
    }

    return (
      <div className="TimeRanges">
        {timeranges}
        <div className="TimeRanges__ButtonWrapper">
          <UI.button
            className="btn-confirm-primary add"
            onClick={this.addTimerange}
            disabled={this.isAddTimerangeDisabled()}
            label="Add Time Slot"
          />
          {tooltipHTML}
        </div>
      </div>
    );
  }
}

export default TimeRanges;



// WEBPACK FOOTER //
// ./src/commons/components/TimeRanges.jsx